<template>
  <div></div>
</template>

<script>
import { getDialog } from '@/libs/vue-utils'
import { loadTossPayments } from '@tosspayments/payment-sdk'

const openDialog = getDialog('dialogType')

export default {
  name: 'RegisterCard',
  props: [
    'userData',
    'registerData'
  ],
  computed: {
    customerUid () {
      return this.registerData.customerUid
    }
  },
  methods: {
    callToss () {
      const clientKey = process.env.VUE_APP_TOSS_API_BILLING_CLIENT
      const close = this.closeCall
      loadTossPayments(clientKey).then(tossPayments => {
        tossPayments
          .requestBillingAuth('카드', {
            customerKey: this.userData.userNum, // 구매자 ID로 상점에서 만들어야 합니다. 빌링키와 매핑됩니다. 자세한 파라미터 설명은 결제 정보 파라미터 설명을 참고하세요.
            successUrl: window.location.href, // 카드 등록에 성공하면 이동하는 페이지(직접 만들어주세요)
            failUrl: window.location.href // 카드 등록에 실패하면 이동하는 페이지(직접 만들어주세요)
          })
          .catch(function (error) {
            if (error.code === 'USER_CANCEL') {
              close()
            }
          })
      })
    },
    closeCall () {
      this.$emit('onRegisterCanceled')
    }
    // callInicis () {
    //   const userData = this.userData
    //   let order = '01'

    //   if (this.customerUid) {
    //     const orderRegex = /_(\d{2})+$/
    //     const matches = this.customerUid.match(orderRegex)

    //     if (matches && matches.length === 2) {
    //       let orderNumber = Number(matches[1]) + 1
    //       if (orderNumber >= 100) {
    //         orderNumber = 1
    //       }
    //       if (orderNumber < 10) {
    //         order = '0' + orderNumber
    //       } else {
    //         order = String(orderNumber)
    //       }
    //     }
    //   }

    //   const dateString = format(new Date(), 'YYYYMMDD_HHmm')
    //   const params = {
    //     pg: 'inicis',
    //     pay_method: 'card',
    //     merchant_uid: `CARD_${userData.userNum}_${dateString}`,
    //     customer_uid: `imp_customer_${userData.userNum}_${order}`,
    //     name: '최초인증결제',
    //     amount: 0,
    //     buyer_email: userData.userId === 'admin' ? 'dev@4grit.com' : userData.userId,
    //     buyer_tel: userData.phoneNumber,
    //     buyer_addr: '경기도 성남시 분당구 삼평동 670',
    //     buyer_postcode: '13494',
    //     buyer_name: userData.userName
    //   }

    //   requestPayment(params).then(result => {
    //     const successData = {
    //       ...result
    //     }
    //     return registerSuccess(successData)
    //   }).then(result => {
    //     this.$emit('onRegisterSuccess', result)
    //   }).catch(error => {
    //     if (error.data) {
    //       if (error.data.data && error.data.data.error_msg === '사용자가 결제를 취소하셨습니다') {
    //         this.$emit('onRegisterCanceled')
    //         return
    //       }

    //       const failedData = {
    //         ...error.data
    //       }
    //       registerFailed(failedData).then(() => {
    //         this.$emit('onRegisterFailed', failedData)
    //       }).catch(err => {
    //         this.$emit('onRegisterFailed', err)
    //       })
    //     } else {
    //       this.$emit('onRegisterFailed', error)
    //     }
    //   })
    // }
  },
  mounted () {
    openDialog('userInfo.registerCard')
      .then(result => {
        if (result) {
          this.callToss()
        } else {
          this.$emit('onRegisterCanceled')
        }
      })
  }
}
</script>

<style>
  .imp-dialog {
    z-index: 99999999 !important;
  }
</style>
